// import topTitle from '@/components/title';
export default {
  // components: {topTitle},
  props: {
    policyInfo: {
      type: Object,
      default() {
        return {};
      }
    }
  }
};